import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "fw-bolder"
}
const _hoisted_7 = {
  key: 1,
  class: "fw-bolder"
}
const _hoisted_8 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-12 form-group mb-7" }
const _hoisted_14 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_15 = { class: "modal-footer justify-content-end gap-2" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "svg-icon svg-icon-3" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "svg-icon svg-icon-3" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_KycAddress = _resolveComponent("KycAddress")!
  const _component_AdditionalSection = _resolveComponent("AdditionalSection")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isEditModal)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.$t("common.edit")), 1))
              : (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.$t("common.add")), 1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.formData,
          rules: _ctx.rules,
          "validate-on-rule-change": false
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.common.identification")), 1),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("kyc.information.warehouseInformation.warehouseName")), 1),
                  _createVNode(_component_el_form_item, { prop: "identification.warehouse_name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.identification.warehouse_name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.identification.warehouse_name) = $event)),
                        disabled: _ctx.updateSection === 'additional'
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_KycAddress, {
                  "update-section": _ctx.updateSection,
                  modelValue: _ctx.formData.identification,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.identification) = $event))
                }, null, 8, ["update-section", "modelValue"])
              ]),
              (_ctx.updateSection === 'additional')
                ? (_openBlock(), _createBlock(_component_AdditionalSection, {
                    key: 0,
                    modelValue: _ctx.formData.additional,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.additional) = $event)),
                    "section-title": 
                _ctx.$t(
                  'kyc.information.warehouseInformation.additionalSectionTitle'
                )
              
                  }, null, 8, ["modelValue", "section-title"]))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.localLoading || _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-light",
                disabled: _ctx.loading,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.modalHide && _ctx.modalHide(...args)))
              }, [
                (!_ctx.localLoading && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.cancel")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, [
                      _hoisted_20,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                    ]))
              ], 8, _hoisted_16),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.localLoading || _ctx.loading,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                (!_ctx.localLoading && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.submit")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      _hoisted_25,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                    ]))
              ], 8, _hoisted_21)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}